/**
 * Lote de requests independentes: uma falha não cancela as outras, e o que deu
 * certo fica gravado. Se nada passou, o primeiro erro sobe para o `onError` da
 * mutação decidir a mensagem; se parte passou, o chamador avisa o desfecho.
 */
export const settleBatch = async <T>(requests: Array<Promise<T>>) => {
  const results = await Promise.allSettled(requests)

  const done = results.flatMap(result =>
    result.status === 'fulfilled' ? [result.value] : []
  )

  if (!done.length) throw (results[0] as PromiseRejectedResult).reason

  return { done, total: results.length, failed: results.length - done.length }
}
